import React, { memo } from "react";
import { useObservable } from "react-use-observable";
import { map, take } from "rxjs";

import { Events, eventsService } from "../../../../../../../services/events";
import Play from "../Play";
import { useCustomPlayerContext } from "../../../../../../../contexts/CustomPlayerContext";

const BigPlay: React.FC = () => {
  const [videoWasPlayed] = useObservable(
    () =>
      eventsService.on(Events.PLAYER_PLAYED).pipe(
        map(() => true),
        take(1)
      ),
    []
  );
  const { customPlayerPreferences } = useCustomPlayerContext();

  if (!videoWasPlayed) {
    return <Play customStyles={{ color: customPlayerPreferences.customTextColor ? customPlayerPreferences.customTextColor : undefined }} size="large" />;
  }

  return <></>;
};

export default memo(BigPlay);
